// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_80-0";
export var optionCard = "_80-1";